export default [
    {
        path: "/bidding/requisition-assignments",
        name: "requisition-assignments",
        meta: {
            title: "All Requisition Assignments",
            authRequired: true,
            privileges: [
                'VIEW_ALL_REQUISITION_ASSIGNMENTS',
            ]
        },
        component: () => import("../views/bidding/requisition-assignments.vue"),
    },
    {
        path: "/bidding/assigned-requisitions",
        name: "assigned-requisitions",
        meta: {
            title: "My Requisitions",
            authRequired: true
        },
        component: () => import("../views/bidding/assigned-requisitions.vue"),
    },
    {
        path: "/bidding/assigned-requisitions/view/:id",
        name: "view-assigned-requisition",
        meta: {
            title: "View Assigned Requisitions",
            authRequired: true
        },
        component: () => import("../views/bidding/view-assigned-requisition.vue"),
    },
    {
        path: "/bidding/requests-for-reassignment",
        name: "requests-for-reassignment",
        meta: {
            title: "Requests for reassignment",
            authRequired: true
        },
        component: () => import("../views/bidding/my-requests-for-reassignment.vue"),
    },
    {
        path: "/bidding/requests-for-reassignment/view/:id",
        name: "view-request-for-reassignment",
        meta: {
            title: "View Request for Reassignment",
            authRequired: true
        },
        component: () => import("../views/bidding/view-reassignment-request.vue"),
    },
    {
        path: "/bidding/all-requests-for-reassignment",
        name: "all-requests-for-reassignment",
        meta: {
            title: "My Requisitions",
            authRequired: true
        },
        component: () => import("../views/bidding/all-requests-for-reassignment.vue"),
    },
    {
        path: "/bidding/requisition-assignments/new",
        name: "new-assignment",
        meta: {
            title: "New Assignment",
            authRequired: true,
            privileges: [
                'ASSIGN_REQUISITIONS',
            ]
        },
        component: () => import("../views/bidding/new-requisition-assignment.vue"),
    },
    {
        path: "/bidding/all-tender-workspaces",
        name: "all-tender-workspaces",
        meta: {
            title: "Tender Workspaces",
            authRequired: true,
            privileges: [
                'VIEW_ALL_TENDER_WORKSPACES',
            ]
        },
        component: () => import("../views/bidding/all-tender-workspaces.vue"),
    },
    /*{
        path: "/bidding/my-tender-workspaces",
        name: "my-tender-workspaces",
        meta: {
            title: "My Tender Workspaces",
            authRequired: true
        },
        component: () => import("../views/bidding/my-tender-workspaces.vue"),
    },*/
    {
        path: "/bidding/tender-workspaces/view/:id",
        name: "view-tender-workspace",
        meta: {
            title: "View Tender Workspace",
            authRequired: true
        },
        component: () => import("../views/bidding/view-tender-workspace.vue"),
    },
    {
        path: "/bidding/eoi/approve",
        name: "approve-expression-of-interest",
        meta: {
            title: "Approve expression of interest",
            authRequired: true
        },
        component: () => import("../views/bidding/approve-expression-of-interest.vue"),
    },
    {
        path: "/bidding/eoi-extension/approve",
        name: "approve-extension",
        meta: {
            title: "Approve Extension of expression of interest",
            authRequired: true
        },
        component: () => import("../views/bidding/approve-extension.vue"),
    }
]